/* eslint-disable no-unused-vars */
import { CustomButton, Label, CustomTooltip, Loader } from 'components';
import { Question } from 'assets/icons';
import { useComputed } from '@preact/signals-react';
import styled from 'styled-components';

const toolTipStyle = {
  color: '#64748B',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '16px',
};
const labelStyle = { marginLeft: 'auto', marginRight: '2px' };

export const ImageUploadHandler = ({
  onImageUpload,
  isDragging,
  dragProps,
  errors,
  uploadResult,
  resolutionWidth,
  resolutionHeight,
}) => {
  return (
    <Box>
      <div style={{ display: 'flex', gap: '8px' }} {...dragProps}>
        <CustomButton
          btnWrapperStyle={{
            height: '32px',
            color: isDragging ? 'red' : 'inherit',
          }}
          square
          id='delete_selected_creative'
          buttonColor={CustomButton.Colors.Secondary}
          onClick={onImageUpload}
        >
          Upload Creative
        </CustomButton>
        <Label
          variant='description'
          text='or Drag and drop files here'
          style={{ whiteSpace: 'nowrap', color: isDragging ? 'red' : 'inherit' }}
        />
      </div>
      {errors && (
        <ErrorBox>
          {errors.acceptType && (
            <Label
              variant='description'
              style={{ color: 'red' }}
              text='Your selected file type is not allowed'
            />
          )}
          {errors.resolution && (
            <Label
              style={{ color: 'red' }}
              text={`Photo resolution should be ${resolutionWidth} * ${resolutionHeight}`}
              variant='description'
            />
          )}
        </ErrorBox>
      )}
      {uploadResult.isLoading && <Loader.Local delay={0} />}
      <Label text='Requirements' variant='description' style={labelStyle} />
      <CustomTooltip
        style={toolTipStyle}
        content={<Question />}
        text={
          <p style={{ maxWidth: '150px' }}>
            JPEG or PNG. Please upload image size {resolutionWidth}*{resolutionHeight}.
          </p>
        }
      />
    </Box>
  );
};

const ErrorBox = styled.div`
  width: 345px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
`;

export const Box = styled.div`
  padding: 16px 24px;
  max-height: 64px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
